import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-stone-900 text-stone-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Top Section */}
        <div className="py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-8">

          {/* Brand Column */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-5">
              <div className="w-9 h-9 bg-teal-500 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-heart-pulse-line text-white text-base"></i>
              </div>
              <div className="flex flex-col leading-tight">
                <span className="font-bold text-sm text-white whitespace-nowrap">The Villarreal Health</span>
                <span className="font-bold text-sm text-teal-400 whitespace-nowrap">Network</span>
              </div>
            </Link>
            <p className="text-stone-400 text-sm leading-relaxed mb-6 max-w-xs">
              A unified platform connecting Nevada families with trusted home-based healthcare, skilled nursing, and specialized caregiving services.
            </p>
            <div className="space-y-2">
              <a href="tel:+17025551234" className="flex items-center gap-2 text-sm text-stone-400 hover:text-teal-400 transition-colors duration-200">
                <i className="ri-phone-line text-teal-500"></i>
                (702) 555-1234
              </a>
              <a href="mailto:info@villarrealhealth.com" className="flex items-center gap-2 text-sm text-stone-400 hover:text-teal-400 transition-colors duration-200">
                <i className="ri-mail-line text-teal-500"></i>
                info@villarrealhealth.com
              </a>
              <p className="flex items-center gap-2 text-sm text-stone-400">
                <i className="ri-map-pin-line text-teal-500"></i>
                Las Vegas, Nevada
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Navigation</h4>
            <ul className="space-y-2.5">
              {[
                { label: 'Home', href: '/' },
                { label: 'Overview', href: '/overview' },
                { label: 'Our Network', href: '/compare' },
                { label: 'For Professionals', href: '/professionals' },
                { label: 'Resources', href: '/resources' },
                { label: 'Contact Us', href: '/contact' },
              ].map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-sm text-stone-400 hover:text-teal-400 transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Network */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Our Network</h4>
            <ul className="space-y-2.5">
              {[
                'Med-Care Providers',
                'Celebrity Home Health',
                'Accent Senior Care',
                'A Peace of Mind Caregivers',
              ].map((name) => (
                <li key={name}>
                  <Link to="/compare" className="text-sm text-stone-400 hover:text-teal-400 transition-colors duration-200">
                    {name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services / CTA */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Services</h4>
            <ul className="space-y-2.5 mb-6">
              {[
                { label: 'Request Care', href: '/referral' },
                { label: 'Emergency Care', href: '/emergency' },
                { label: 'Insurance Check', href: '/insurance' },
                { label: 'Care Assessment', href: '/assessment' },
                { label: 'Consultation', href: '/consultation' },
              ].map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-sm text-stone-400 hover:text-teal-400 transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <Link
              to="/referral"
              className="inline-block bg-teal-600 hover:bg-teal-500 text-white text-sm font-semibold px-4 py-2.5 rounded-lg transition-colors duration-200 whitespace-nowrap"
            >
              Get Care Now
            </Link>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-5 border-t border-stone-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-stone-500">
            &copy; {new Date().getFullYear()} The Villarreal Health Network. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="text-xs text-stone-500 hover:text-stone-300 transition-colors duration-200">
              Privacy Policy
            </Link>
            <span className="text-stone-700">|</span>
            <a
              href="https://readdy.ai/?origin=logo"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-xs text-stone-500 hover:text-stone-300 transition-colors duration-200"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
